
<div :id="content.idHTML" :class="jel_getClassObject(content)">
  <div v-show="etat === CONSTANT.etat.mfaoptions">
    <Titre
      :content="{
        titre: content.mfaTitre,
        type: 'grandTitre',
      }"
    ></Titre>

    <MessageMel
      v-show="contentMessageMel.message"
      :content="contentMessageMel"
      class="mt-n1 mt-md-0 mb-1"
    ></MessageMel>

    <Paragraphe
      :content="{
        richText: content.txtMFA,
        //classeCSS: 'pb-1',
      }"
    ></Paragraphe>

    <Hyperlien :content="contentLienAideMFA"></Hyperlien>

    <div class="row">
      <div class="col">
        <b-form
          :action="formAction"
          method="post"
          @click="setMFAOption($event)"
          @submit="onSubmit()"
        >
          <!-- mfaopref est passé dans le POST -->
          <input v-model="mfaOption" name="mfaopref" type="hidden" />

          <b-button
            id="buttonPrefYes"
            class="btn btn-primaire px-4 my-2 mx-auto mx-md-0 d-block"
            type="submit"
            :disabled="isSubmitted"
          >
            {{ content.txtActiverMFA }}
          </b-button>

          <b-button
            id="buttonPrefNo"
            class="lienSecondaire mb-2 mx-auto mx-md-0 d-block"
            type="submit"
            :disabled="isSubmitted"
          >
            {{ content.txtRefuserMFA }}
          </b-button>
        </b-form>
      </div>
    </div>
  </div>
</div>
